<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-2">
                <b-field>
                    <b-input :placeholder="$t('SISTEMA.CODIGO')" v-model="procurarCodigo" icon="magnify" @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('SISTEMA.PROCURAR')" v-model="procurar" icon="magnify" @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="is-flex is-justified-between">
                    <router-link v-if="isInRole('prd-clientes-alterar')" :to="{ name: 'cliente' }" class="button is-primary">
                        {{ $t('SISTEMA.INCLUIR') }}
                    </router-link>
                </div>
            </div>
        </div>
        <b-table
            :data="model.lista"
            :loading="loading"
            paginated
            striped
            hoverable
            backend-pagination
            :total="total"
            @page-change="onPageChange"
            :aria-next-label="$t('SISTEMA.PROXPAGINA')"
            :aria-previous-label="$t('SISTEMA.PAGANTERIOR')"
            :aria-page-label="$t('SISTEMA.PAGINA')"
            :aria-current-label="$t('SISTEMA.PAGATUAL')"
            backend-sorting
            :default-sort-direction="defaultOrdenar"
            :default-sort="[ordenarPor, ordenar]"
            sort-icon-size="is-small"
            @sort="onSort"
        >
            <template>
                <b-table-column field="código" :label="$t('SISTEMA.CODIGO')" v-slot="props">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column field="Nome" :label="$t('SISTEMA.NOME')" v-slot="props">
                    {{ props.row.nome }}
                </b-table-column>

                <b-table-column field="RazaoSocial" label="Razão social" v-slot="props">
                    {{ props.row.razaoSocial }}
                    <small v-if="props.row.nomeFantasia" class="is-block has-text-grey">{{ props.row.nomeFantasia }}</small>
                </b-table-column>

                <b-table-column field="CPF" label="CPF/CNPJ" v-slot="props">
                    {{ props.row.cpf }}
                </b-table-column>

                <b-table-column field="Contato" label="Contato" v-slot="props">
                    <div v-if="props.row.celular || props.row.fone || props.row.email" class="cliente-contato">
                        <div v-if="props.row.celular" class="cliente-contato-item">
                            <button
                                type="button"
                                class="cliente-contato-whatsapp"
                                title="Iniciar conversa no WhatsApp"
                                @click="abrirWhatsapp(props.row)"
                            >
                                <b-icon icon="whatsapp" type="is-success" size="is-small"></b-icon>
                            </button>
                            <span>
                                <small>Celular</small>
                                {{ props.row.celular }}
                            </span>
                        </div>

                        <button
                            v-if="props.row.fone || props.row.email"
                            type="button"
                            class="cliente-outros-contatos-botao"
                            :aria-expanded="Boolean(outrosContatosAbertos[props.row.id])"
                            :aria-controls="`outros-contatos-${props.row.id}`"
                            @click="alternarOutrosContatos(props.row.id)"
                        >
                            <span>Outros contatos</span>
                            <b-icon :icon="outrosContatosAbertos[props.row.id] ? 'chevron-up' : 'chevron-down'" size="is-small"></b-icon>
                        </button>

                        <div
                            v-if="(props.row.fone || props.row.email) && outrosContatosAbertos[props.row.id]"
                            :id="`outros-contatos-${props.row.id}`"
                            class="cliente-outros-contatos"
                        >
                            <div v-if="props.row.fone" class="cliente-contato-item">
                                <b-icon icon="phone" size="is-small"></b-icon>
                                <span>
                                    <small>Telefone</small>
                                    {{ props.row.fone }}
                                </span>
                            </div>
                            <div v-if="props.row.email" class="cliente-contato-item">
                                <b-icon icon="email-outline" size="is-small"></b-icon>
                                <span>
                                    <small>E-mail</small>
                                    {{ props.row.email }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <span v-else class="has-text-grey-light">—</span>
                </b-table-column>

                <b-table-column field="desativado" label="" v-slot="props">
                    <b-icon v-if="props.row.desativado" type="is-danger" icon="close-circle" :title="$t('CLIENTESLISTA.DESATIVADO')"></b-icon>
                </b-table-column>

                <b-table-column custom-key="actions" numeric v-slot="props">
                    <router-link
                        :to="{ name: 'cliente', params: { id: props.row.id, criarGuia: criarGuia } }"
                        class="button is-small is-primary"
                        :title="$t('SISTEMA.EDITAR')"
                    >
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
import http from '@/http'
import { mapGetters, mapState } from 'vuex'
import titlebar from '@/components/titlebar.vue'
import debounce from 'lodash/debounce'

export default {
    data() {
        return {
            model: [],
            total: 0,
            loading: false,
            procurar: this.$route.query.procurar ?? this.$route.params.procurar ?? '',
            procurarCodigo: null,
            criarGuia: Boolean(this.$route.params.criarGuia) ?? false,
            ordenarPor: 'Nome',
            ordenar: 'asc',
            defaultOrdenar: 'asc',
            page: 1,
            perPage: 20,
            selecionado: null,
            id: null,
            outrosContatosAbertos: {},
        }
    },
    components: {
        titlebar,
    },
    computed: {
        ...mapState(['unidadeId']),
        titleStack() {
            return ['Configurações', 'Clientes']
        },
        ...mapGetters(['isInRole']),
    },
    watch: {
        unidadeId: function () {
            this.loadAsyncData()
        },
    },
    methods: {
        loadAsyncData: debounce(function () {
            const params = [`ordem=${this.ordenarPor}.${this.ordenar}`, `page=${this.page}`, `unidadeId=${this.unidadeId}`, `retornarDesativados=false`]

            if (this.procurarCodigo) {
                params.push(`procurarCodigo=${this.procurarCodigo}`)
            } else if (this.procurar) {
                params.push(`procurar=${this.procurar}`)
            }

            this.loading = true
            http.get(`/api/manutencao/clientes?${params.join('&')}`)
                .then(({ data }) => {
                    this.model = data
                    if (data.lista.length == 0 && this.page > 1) {
                        this.page = 1
                        this.loadAsyncData()
                    }
                    this.total = this.perPage * data.pageCount
                    this.loading = false
                })
                .catch((error) => {
                    this.model = []
                    this.total = 0
                    this.loading = false
                    throw error
                })
        }, 500),
        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
        onSort(field, order) {
            this.ordenarPor = field
            this.ordenar = order
            this.loadAsyncData()
        },
        alternarOutrosContatos(clienteId) {
            this.$set(this.outrosContatosAbertos, clienteId, !this.outrosContatosAbertos[clienteId])
        },
        abrirWhatsapp(cliente) {
            const celular = String(cliente.celular || '').replace(/\D/g, '')
            if (celular.length < 10) return

            const numeroWhatsapp = celular.length <= 11 ? `55${celular}` : celular
            const mensagem = `Olá, ${cliente.nome}! Aqui é da ${cliente.unidadeNome}. Estamos entrando em contato com você. Tudo bem?`
            const url = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagem)}`

            window.open(url, '_blank', 'noopener,noreferrer')
        },
    },
    mounted() {
        this.loadAsyncData()
    },
}
</script>

<style scoped>
.cliente-contato {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.cliente-contato-item {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
}

.cliente-contato-item small {
    display: block;
    color: #7a7a7a;
    font-size: 0.7rem;
    line-height: 1;
}

.cliente-outros-contatos-botao {
    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: 0.15rem;
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--brand-teal-600);
    font-size: 0.7rem;
    cursor: pointer;
}

.cliente-outros-contatos-botao:hover,
.cliente-outros-contatos-botao:focus-visible {
    color: var(--brand-navy-700);
    text-decoration: underline;
    outline: none;
}

.cliente-outros-contatos {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    margin-top: 0.1rem;
    padding: 0.35rem 0 0.1rem 0.55rem;
    border-left: 2px solid var(--border-soft);
}

.cliente-contato-whatsapp {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
}

.cliente-contato-whatsapp:hover,
.cliente-contato-whatsapp:focus-visible {
    filter: brightness(0.85);
    outline: none;
}
</style>
